import * as React from 'react';
import { useTheme } from '../../../theme';
const ServiceSummaryDivider = ({ children }) => {
    const theme = useTheme('ServiceSummary').ServiceSummaryDivider;
    return React.createElement("div", { className: theme.container }, children);
};
export default ServiceSummaryDivider;
